import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { bindKeymapWithCommand, openHelp } from '@atlaskit/editor-common/keymaps';
import { keymap } from '@atlaskit/editor-prosemirror/keymap';
import { openHelpCommand } from './commands';
import { pluginKey } from './plugin-key';
export var keymapPlugin = function keymapPlugin(editorAnalyticsAPI) {
  var list = {};
  bindKeymapWithCommand(openHelp.common, function (state, dispatch) {
    var tr = state.tr;
    var isVisible = tr.getMeta(pluginKey);
    if (!isVisible) {
      editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: ACTION.CLICKED,
        actionSubject: ACTION_SUBJECT.BUTTON,
        actionSubjectId: ACTION_SUBJECT_ID.BUTTON_HELP,
        attributes: {
          inputMethod: INPUT_METHOD.SHORTCUT
        },
        eventType: EVENT_TYPE.UI
      })(tr);
      openHelpCommand(tr, dispatch);
    }
    return true;
  }, list);
  return keymap(list);
};